(() => {
  if (window.BreatheSearchScope?.buildSearchUrl) return;
  const buildSearchUrl = (action, value) => {
    const query = (value || '').trim();
    if (!query) return null;
    const url = new URL(action, location.origin);
    url.search = '';
    url.hash = '';
    url.searchParams.set('q', query);
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[prefix]', 'last');
    return url;
  };
  window.BreatheSearchScope = { toTitleQuery: value => (value || '').trim(), buildSearchUrl };
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || form.method.toLowerCase() !== 'get') return;
    if (!new URL(form.action, location.href).pathname.replace(/\/$/, '').endsWith('/search')) return;
    const input = form.querySelector('input[name="q"]');
    if (!input) return;
    event.preventDefault();
    const url = buildSearchUrl(form.action, input.value);
    if (!url) { input.focus(); return; }
    location.assign(url.toString());
  }, true);
})();
